<ng-container *ngFor="let treatment of treatments$ | async">
    <div *ngIf="treatment !== offPathwayKey; else offPathwayEntry" class="pathway-treatment-item">{{treatment}}</div>
    <ng-template #offPathwayEntry>
        <div class="pathway-treatment-item">{{treatment | translate}}</div>
    </ng-template>
</ng-container>
